import { styled } from "@mui/material";

export const ChatChartPlaceholder = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  height: 350,
  border: `2px dashed ${theme.palette.mode === "dark" ? "#555" : "#ccc"}`,
  borderRadius: "8px",
  color: theme.palette.mode === "dark" ? "#aaa" : "#666",
  fontSize: "14px",
}));
